'use strict';

exports.__esModule = true;
var ADD_GROUP = exports.ADD_GROUP = 'ADD_GROUP';
var REMOVE_GROUP = exports.REMOVE_GROUP = 'REMOVE_GROUP';
var SET_CONJUNCTION = exports.SET_CONJUNCTION = 'SET_CONJUNCTION';
var SET_NOT = exports.SET_NOT = 'SET_NOT';

var ADD_NEW_GROUP = exports.ADD_NEW_GROUP = 'ADD_NEW_GROUP';
var ADD_RULE = exports.ADD_RULE = 'ADD_RULE';
var REMOVE_RULE = exports.REMOVE_RULE = 'REMOVE_RULE';
var SET_FIELD = exports.SET_FIELD = 'SET_FIELD';
var SET_OPERATOR = exports.SET_OPERATOR = 'SET_OPERATOR';
var SET_VALUE = exports.SET_VALUE = 'SET_VALUE';
var SET_VALUE_SRC = exports.SET_VALUE_SRC = 'SET_VALUE_SRC';
var SET_OPERATOR_OPTION = exports.SET_OPERATOR_OPTION = 'SET_OPERATOR_OPTION';

var SET_TREE = exports.SET_TREE = 'SET_TREE';

var MOVE_ITEM = exports.MOVE_ITEM = 'MOVE_ITEM';

var PLACEMENT_AFTER = exports.PLACEMENT_AFTER = 'after';
var PLACEMENT_BEFORE = exports.PLACEMENT_BEFORE = 'before';
var PLACEMENT_APPEND = exports.PLACEMENT_APPEND = 'append';
var PLACEMENT_PREPEND = exports.PLACEMENT_PREPEND = 'prepend';

// export const SET_DRAGGING = 'SET_DRAGGING';
// export const SET_DRAG_START = 'SET_DRAG_START';
// export const SET_MOUSE_POS = 'SET_MOUSE_POS';
var SET_DRAG_PROGRESS = exports.SET_DRAG_PROGRESS = 'SET_DRAG_PROGRESS';
var SET_DRAG_START = exports.SET_DRAG_START = 'SET_DRAG_START';
var SET_DRAG_END = exports.SET_DRAG_END = 'SET_DRAG_END';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-awesome-query-builder/build/npm/lib/constants.js
// module id = 336
// module chunks = 0